// extracted by mini-css-extract-plugin
module.exports = {"simpleBarContainer":"SimpleBar_simpleBarContainer__3wyW_"};